document.addEventListener('alpine:init', () => {
    Alpine.data('container', (context) => ({
        visible: true,
        currentContext: null,

        init() {
            this.currentContext = pegasus.getCookie('selectedOption') || 'candidate';
            this.visible = context === '' || this.currentContext === context;

            window.addEventListener('context-switched', (e) => { 
                console.log(e.detail.context);
                this.visible = context === '' || e.detail.context === context;
            });
        },
    }))
});
